import { getFramework } from '../../../sdkReduxConfig';
import { MillisecondTimes } from '../../../utils';
import { invalidateCacheTagsForEvents } from './invalidateCacheTagsForEvents';
/**
 * Monitors given address for next event to invalidate cache and then stops.
 * NOTE: Optimizations for robustness could be done here.
 * @private
 * @category Cache Tags
 */
export const monitorAddressForNextEventToInvalidateCache = async (address, transactionInfo, dispatch) => {
    const framework = await getFramework(transactionInfo.chainId);
    framework.query.on((events, unsubscribe) => {
        invalidateCacheTagsForEvents(transactionInfo.chainId, events, dispatch);
        unsubscribe();
    }, MillisecondTimes.OneSecond, address, MillisecondTimes.OneMinute);
};
//# sourceMappingURL=monitorAddressForNextEventToInvalidateCache.js.map